import { create } from 'zustand';
import type { GridLayoutItem } from '../types/dashboard.types';

interface DashboardUIState {
  activeDashboardId: string | null;
  isEditMode: boolean;
  isSidebarOpen: boolean;
  pendingLayoutChanges: GridLayoutItem[] | null;
  selectedCardId: string | null;

  setActiveDashboardId: (id: string | null) => void;
  setEditMode: (isEdit: boolean) => void;
  toggleEditMode: () => void;
  setSidebarOpen: (isOpen: boolean) => void;
  toggleSidebar: () => void;
  setPendingLayoutChanges: (layout: GridLayoutItem[] | null) => void;
  setSelectedCardId: (cardId: string | null) => void;
  discardLayoutChanges: () => void;
  hasUnsavedChanges: () => boolean;
}

export const useDashboardUIStore = create<DashboardUIState>((set, get) => ({
  activeDashboardId: null,
  isEditMode: false,
  isSidebarOpen: false,
  pendingLayoutChanges: null,
  selectedCardId: null,

  setActiveDashboardId: (id) => set({ activeDashboardId: id }),

  setEditMode: (isEdit) =>
    set({
      isEditMode: isEdit,
      selectedCardId: isEdit ? get().selectedCardId : null,
    }),

  toggleEditMode: () => {
    const current = get().isEditMode;
    set({
      isEditMode: !current,
      selectedCardId: !current ? get().selectedCardId : null,
    });
  },

  setSidebarOpen: (isOpen) => set({ isSidebarOpen: isOpen }),

  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),

  setPendingLayoutChanges: (layout) => set({ pendingLayoutChanges: layout }),

  setSelectedCardId: (cardId) => set({ selectedCardId: cardId }),

  discardLayoutChanges: () => set({ pendingLayoutChanges: null }),

  hasUnsavedChanges: () => get().pendingLayoutChanges !== null,
}));
